export default __webpack_public_path__ + "static/media/ul.7dd775b5.svg";